import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';

import { CartService } from '../../../../core/service/cart-apis/cart.service';
import { Product } from '../../../../features/establishment-main/components/products/interfaces/products.interface';
import { UpdateQuantity } from '../../../../core/service/cart-apis/interfaces/cart.interface';
import { SyncPricesCartService } from '../../../../core/service/sync-prices-cart/sync-prices-cart.service';
import { ProductData } from '../../../../features/establishment-main/components/list-products/interfaces/list-products-new.interface';

@Injectable({
  providedIn: 'root'
})
export class ShopCartService implements OnDestroy {

  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();
  private routerSubscription: Subscription;

  constructor(
    private cartService: CartService,
    private syncPricesCartService: SyncPricesCartService,
    private router: Router
  ) {
    // Cerrar el carrito en CUALQUIER navegación
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isOpenSubject.next(false);
      }
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  toggleCart(value?: boolean): void {
    // Si estamos en la ruta de pago, cerrar el carrito y no permitir que se abra
    if (this.router.url === '/auth/detail-orden-payment') {
      this.isOpenSubject.next(false);
      return;
    }

    const newValue = value !== undefined ? value : !this.isOpenSubject.value;
    this.isOpenSubject.next(newValue);
  }

  get isOpen(): boolean {
    return this.isOpenSubject.value;
  }

  addNewProduct(product: Product | ProductData): Observable<any> {
    return this.cartService.addCartForApi(product).pipe(
      tap(() => {
        this.getProductsApi().subscribe({
          next: () => {
            // Cart data refreshed after adding product
          },
          error: (error) => {

          }
        });
      })
    );
  }

  getProductsApi() {
    return this.cartService.getCartFromApi();
  }

  getProducts() {
    return this.cartService.getProducts();
  }

  getTotalItems(): Observable<number> {
    return this.cartService.getTotalItems();
  }

  clearCart() {
    return this.cartService.clearCart();
  }

  removeProductFromCart(producId: string) {
    return this.cartService.removeItemFromCart(producId);
  }

  updateQuantity(pd_id: string, quantity: number): Observable<any> {
    const product: UpdateQuantity = {
      shopping: {
        items: [{
          product_id: pd_id,
          quantity: quantity
        }]
      }
    };
    return this.cartService.updateItemQuantity(product).pipe(
      tap((response) => {
        // Update quantity response logged
      })
    );
  }
}
